<div mat-dialog-title class="search-detail__header">
  <div class="search-detail__header-text">
    {{ dj2DetailData.searchResponse?.primary_name }}
    <span class="search-detail__sub-heading">
      (#{{ dj2DetailData?.searchResponse?.dj_id }})
    </span>
  </div>
  <div class="search-detail__close" (click)="closeDialog()">
    <img class="themified-white-icon search-detail__close-icon" src="/assets/icons/cross-icon.png" />
  </div>
</div>

<div mat-dialog-content class="search-detail__content">

  <ng-container *ngFor="let keySection of getKeyObject(dj2DetailData.searchResponse)">

    <!-- VALUE IS STRING, BIG SECTION -->
    <ng-container *ngIf="!isArray(dj2DetailData.searchResponse[keySection]) && !isObject(dj2DetailData.searchResponse[keySection])
                        && dj2DetailData.searchResponse[keySection]">
      <div class="search-detail__column">
        <div class="search-detail__title">{{ convertTextTitleAndHeader(keySection) }}</div>
        <div class="search-detail__text">
          <div class="search-detail__item search-detail__item-text">
            <ng-container *ngIf="keySection === 'last-review-date'; else notSectionLastReviewDate">
              {{ dj2DetailData.searchResponse[keySection] | date:'dd/MM/yyyy' }}
            </ng-container>
            <ng-template #notSectionLastReviewDate>
              {{ dj2DetailData.searchResponse[keySection] }}
            </ng-template>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- VALUE IS ARRAY, BIG SECTION-->
    <ng-container *ngIf="isArray(dj2DetailData.searchResponse[keySection]) && (dj2DetailData.searchResponse[keySection].length > 0)">
      <div class="search-detail__column">
        <div class="search-detail__title">{{ convertTextTitleAndHeader(keySection) }}</div>
        <div class="search-detail__text">

          <!-- item of array is string -->
          <ng-container *ngIf="!isObject(dj2DetailData.searchResponse[keySection][0])">
            <ng-template ngFor let-data [ngForOf]="dj2DetailData.searchResponse[keySection]">
              <ng-container *ngIf="keySection === 'image-details'; else isNotImageDetails">
                <div class="search-detail__item search-detail__item_md12">
                  <a class="link link_underlined" target="_blank" [href]="data">{{ data }}</a>
                </div>
              </ng-container>
              <ng-template #isNotImageDetails>
                <div class="search-detail__item search-detail__item_md3">
                  <span class="search-detail__item-text">{{ data }}</span>
                </div>
              </ng-template>
            </ng-template>
          </ng-container>

          <!-- item of array is object -->
          <ng-container *ngIf="isObject(dj2DetailData.searchResponse[keySection][0])">
            <div class="search-detail__wrap-table">
              <table class="search-detail__table">
                <thead>
                  <tr>
                    <th class="search-detail__item search-detail__item-header search-detail__table-header"
                        *ngFor="let keyObj of getAllKeyObjectInArray(dj2DetailData.searchResponse[keySection])">
                      {{ convertTextTitleAndHeader(keyObj) }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let itemArr of dj2DetailData.searchResponse[keySection]">
                    <td *ngFor="let keyObj of allKeyObjectInArray" class="search-detail__item">
                      <ng-container *ngIf="isArray(itemArr[keyObj]); else textInObjectInArray">
                        <ng-container *ngIf="itemArr[keyObj].length > 0; else emptyTextInObjectInArray ">
                          <ng-template ngFor let-itemArrInObjInArr  [ngForOf]="itemArr[keyObj]">
                            <div class="search-detail__item-sub-text" *ngFor="let itemTextInObjectInArray of itemArrInObjInArr | keyvalue">
                              <span class="search-detail__item-sub-key">{{convertTextTitleAndHeader(itemTextInObjectInArray.key)}}:</span>
                               {{itemTextInObjectInArray.value || '-'}}
                            </div>
                          </ng-template>
                        </ng-container>
                        <ng-template #emptyTextInObjectInArray>-</ng-template>
                      </ng-container>
                      <ng-template #textInObjectInArray>
                        <ng-container *ngIf="(keySection === 'address_details') && (keyObj === 'address-url'); else isNotAddressURL">
                          <a class="link link_underlined" target="_blank" href="{{itemArr[keyObj]}}"
                            *ngIf="itemArr[keyObj]; else emptyAddressURL">{{ itemArr[keyObj] }}</a>
                          <ng-template #emptyAddressURL>-</ng-template>
                        </ng-container>
                        <ng-template #isNotAddressURL>{{ itemArr[keyObj] || '-' }}</ng-template>
                      </ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
        </div>
      </div>

    </ng-container>

    <!-- VALUE IS OBJECT, BIG SECTION  -->
    <ng-container *ngIf="isObject(dj2DetailData.searchResponse[keySection])
                  && (getKeyObject(dj2DetailData.searchResponse[keySection]).length > 0)">
      <div class="search-detail__column">
        <div class="search-detail__title">{{ convertTextTitleAndHeader(keySection) }}</div>
        <ng-container *ngFor="let keySubSection of getKeyObject(dj2DetailData.searchResponse[keySection])">

          <!-- Value of object is String -->
          <ng-container *ngIf="!isArray(dj2DetailData.searchResponse[keySection][keySubSection]) && !isObject(dj2DetailData.searchResponse[keySection][keySubSection])
                              && dj2DetailData.searchResponse[keySection][keySubSection]">
            <div class="search-detail__title search-detail__sub-title">{{ convertTextTitleAndHeader(keySubSection) }}</div>
            <div class="search-detail__text">
              <div class="search-detail__item search-detail__item-text">
                {{ dj2DetailData.searchResponse[keySection][keySubSection] }}
              </div>
            </div>
          </ng-container>

          <!-- Value of object is array -->
          <ng-container *ngIf="isArray(dj2DetailData.searchResponse[keySection][keySubSection])
                              && (dj2DetailData.searchResponse[keySection][keySubSection].length > 0)">
            <div class="search-detail__title search-detail__sub-title">{{ convertTextTitleAndHeader(keySubSection) }}</div>
            <div class="search-detail__text">

              <!-- Item of array is string -->
              <ng-container *ngIf="!isObject(dj2DetailData.searchResponse[keySection][keySubSection][0])">
                <ng-template ngFor let-data [ngForOf]="dj2DetailData.searchResponse[keySection][keySubSection]">
                  <div class="search-detail__item search-detail__item_md12">
                    <ng-container *ngIf="((keySection === 'adverse-media-content') || (keySection === 'watchlist_content')) && (keySubSection === 'source-details'); else isNotSourceDetails">
                      <ng-container *ngIf="isTextValid(data); else isTextInvalid">
                        <a class="link link_underlined" target="_blank" [href]="convertUrlWithAscensionNumber(data)">{{ data }}</a>
                      </ng-container>
                      <ng-template #isTextInvalid><a target="_blank">{{ data }}</a></ng-template>
                    </ng-container>
                    <ng-template #isNotSourceDetails>
                      <div class="search-detail__item-text">{{ data }}</div>
                    </ng-template>
                  </div>
                </ng-template>
              </ng-container>

              <!-- Item of array is object -->
              <ng-container *ngIf="isObject(dj2DetailData.searchResponse[keySection][keySubSection][0])">
                <div class="search-detail__wrap-table">
                  <table class="search-detail__table">
                    <thead>
                      <tr>
                        <th class="search-detail__item search-detail__item-header search-detail__table-header"
                            *ngFor="let keyObj of getAllKeyObjectInArray(dj2DetailData.searchResponse[keySection][keySubSection])">
                            {{ convertTextTitleAndHeader(keyObj) }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let itemArr of dj2DetailData.searchResponse[keySection][keySubSection]">
                        <td class="search-detail__item" *ngFor="let keyObj of allKeyObjectInArray">
                          <ng-container *ngIf="isArray(itemArr[keyObj]); else valueTextIsString">

                            <ng-template ngFor let-subSubTitle [ngForOf]="getAllKeyObjectInArray(itemArr[keyObj])">
                              <div class="search-detail__title search-detail__item-header">
                                {{ convertTextTitleAndHeader(subSubTitle) }}
                              </div>
                              <ng-template ngFor let-subItemArrKeyObj [ngForOf]="itemArr[keyObj]">
                                <ng-container *ngIf="isArray(subItemArrKeyObj[subSubTitle])">
                                  <div  class="search-detail__item-sub-text" *ngFor="let subSubItemArrKeyObj of subItemArrKeyObj[subSubTitle]" >
                                    <div *ngFor="let subSubItemKeyValue of subSubItemArrKeyObj | keyvalue">
                                      <span class="search-detail__item-sub-key">{{convertTextTitleAndHeader(subSubItemKeyValue.key)}}:</span>
                                        {{ subSubItemKeyValue.value || '-'}}
                                    </div>
                                  </div>
                                </ng-container>

                              </ng-template>
                            </ng-template>
                          </ng-container>
                          <ng-template #valueTextIsString>{{ itemArr[keyObj] || '-' }}</ng-template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>

  <!-- DOWNLOAD -->
  <div class="search-detail__column search-detail__column-action" *ngIf="dj2DetailData.scanType !== 'ODD'">
    <button ubi-round-button mat-button class="btn btn_accent-gradient-rounded" (click)="downloadPDF()">
      Download as PDF
    </button>
  </div>
</div>
